const url = require('url');

const RECOGNIZED_DOMAINS = ['vimeo.com', 'youtube.com'];

const videoUtilities = {
    extractDomain(videoUrl) {
        const urlInfo = url.parse(videoUrl);
        if (!urlInfo.hostname) {
            throw new Error('Unable to parse the url');
        }
        const domain = urlInfo.hostname.replace('www.', '');
        if (RECOGNIZED_DOMAINS.indexOf(domain) === -1) {
            throw new Error(`Videos from domain '${domain}' are not supported.`);
        } else {
            return domain;
        }
    },

    extractVideoId(videoUrl) {
        const domain = videoUtilities.extractDomain(videoUrl);
        const urlInfo = url.parse(videoUrl);
        switch (domain) {
            case 'youtube.com':
                try {
                    return videoUrl.match(/\/watch\?v=([^&]+)/)[1];
                } catch (error) {
                    throw new Error(`Could not extract a youtube video id from '${videoUrl}'`);
                }
            case 'vimeo.com':
                return urlInfo.path.replace('/', '');
            default:
                return undefined;
        }
    },

    getVideoEmbedUrl(videoUrl) {
        const domain = videoUtilities.extractDomain(videoUrl);
        const videoId = videoUtilities.extractVideoId(videoUrl);
        switch (domain) {
            case 'youtube.com':
                return `https://www.youtube.com/embed/${videoId}`;
            case 'vimeo.com':
                return `https://player.vimeo.com/video/${videoId}`;
            default:
                return undefined;
        }
    },

    getVideoThumbnailUrl(window, videoUrl) {
        const domain = videoUtilities.extractDomain(videoUrl);
        const videoId = videoUtilities.extractVideoId(videoUrl);
        switch (domain) {
            case 'youtube.com':
                return videoId && `https://i.ytimg.com/vi/${videoId}/mqdefault.jpg`;
            case 'vimeo.com':
                return `${window.location.protocol}//${window.location.host}/${window.location.pathname.replace(
                    /(^\/|\/$)/g,
                    ''
                )}/api/vimeo-thumbnail/${videoId}`;
            default:
                return undefined;
        }
    },
};

module.exports = videoUtilities;
